<template>
  <div>
    <div class="container-fluid d-flex justify-content-center">
      <div class="col-lg-8">
        <div class="form-main-title">
          <h1>My chances of scholarship</h1>
        </div>
        <div class="form-accordion mt-5" role="tablist">
          <div no-body class="accordion-box">
            <div block v-b-toggle.collapse-1 class="accordion-btn">
              Where would you like to study?
            </div>
            <b-collapse id="collapse-1">
              <div class="accordion-body">
                <div>
                  <b-form-radio-group
                    class="form-radio-btns"
                    v-model="selected"
                    :options="[
                      'UK',
                      'USA',
                      'New Zealand',
                      'China',
                      'Germany',
                      'Russia',
                    ]"
                    :aria-describedby="ariaDescribedby"
                    name="radio"
                    button-variant="outline-primary"
                    buttons
                  ></b-form-radio-group>
                </div>
              </div>
            </b-collapse>
          </div>
          <div no-body class="">
            <div block v-b-toggle.collapse-2 class="accordion-btn">
              Have you appeared for any of the following test?
            </div>
            <b-collapse id="collapse-2">
              <div class="accordion-body">
                <div class="">
                  <b-form-checkbox-group
                    class="form-radio-btns"
                    v-model="selected1"
                    :options="['GRE', 'TOEFL']"
                    :aria-describedby="ariaDescribedby"
                    name="checkbox"
                    button-variant="outline-primary"
                    buttons
                  ></b-form-checkbox-group>
                </div>
                <div></div>
              </div>
            </b-collapse>
          </div>
          <div no-body class="">
            <div block v-b-toggle.collapse-3 class="accordion-btn">
              You want to persue programme in?
            </div>
            <b-collapse id="collapse-3">
              <div class="accordion-body">
                <div class="w-50">
                  <b-dropdown
                    variant="default"
                    class="form-dropdown"
                  >
                    <template slot="button-content">
                      <div class="dropdown-content">Type or select programme below</div>
                    </template>
                    <b-dropdown-item v-for="(data, index) in 10" :key="index"
                      >Type or select programme below</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
        <div class="form-submit mt-4 d-flex justify-content-center">
            <button class="btn btn-primary btn-common-1 w-50">View results</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forms/ScholarshipForm.vue